module.exports = __webpack_public_path__ + "img/Article-image19.8890a476.jpg";